import React, {useEffect, useRef} from 'react';
import {Flex, Button, HTMLDialog, Text} from '@priority-software/priority-style-react';
import {DialogToolbarContent} from '../../../../../../components/Dialog/DialogToolbar/DialogToolbar';
import texts from '../../../../texts';
import {getGroupTitle} from '../../../../utils';
import {DefaultGroupsIDs} from '../../../../enums';

type Props = {
    onClose: () => void;
    groupName?: string;
    onAccept: (groupName: string) => void;
};

export const DeleteGroupDialog = (props: Props) => {
    const {onClose, onAccept, groupName: uniqueGroupId} = props;
    const groupName = getGroupTitle(uniqueGroupId);
    const acceptBtnRef = useRef(null);
    const isInsightsGroup = uniqueGroupId === DefaultGroupsIDs.insights;

    useEffect(() => {
        requestAnimationFrame(() => acceptBtnRef.current?.focus());
    }, []);

    const onDeleteGroup = () => {
        onAccept(uniqueGroupId);
    };

    return (
        <HTMLDialog
            isOpen
            width={520}
            onClose={onClose}
            toolbarContent={
                <DialogToolbarContent
                    mainTitle={
                        isInsightsGroup
                            ? texts.remove_insights_dialog_title
                            : texts.remove_group_dialog_title.replace('X', groupName)
                    }
                    subTitleColor="primary-500"
                />
            }
            content={
                <Text skin="paragraph-1">
                    {isInsightsGroup
                        ? texts.remove_insights_dialog_content
                        : texts.remove_group_dialog_content.replace('X', groupName)}
                </Text>
            }
            footer={
                <Flex justifyContent="flex-end" style={{gap: 24}}>
                    <Button wideButton size="large" onClick={onClose} skin="secondary">
                        {texts.btn_cancel}
                    </Button>
                    <Button
                        inputRef={acceptBtnRef}
                        size="large"
                        wideButton
                        onClick={onDeleteGroup}
                        skin="primary"
                    >
                        {texts.remove_label}
                    </Button>
                </Flex>
            }
        />
    );
};
